import { useState, useEffect,useContext } from 'react';
import { useParams,useNavigate } from 'react-router-dom';
import { CartContext } from '../CartContex';

const ProductPage = () => {
    const [product, setProduct] = useState({});
    const params = useParams();
    const navigate = useNavigate();

    const [isAdding, setIsAdding] = useState(false);
    const { cart, setCart } = useContext(CartContext);
 

    useEffect(() => {
        const fetchProduct = async () => {
            try {
                const response = await fetch('/products.json');
                if (!response.ok) {
                    throw new Error('Failed to fetch products');
                }
                const data = await response.json();
                const foundProduct = data.find(prod => prod.id === parseInt(params.id));
    
                if (!foundProduct) {
                  console.log('Product not found');
                  return; // Exit function if product is not found
                }
                setProduct(foundProduct);
            } catch (error) {
                console.error('Error fetching products:', error);
            }
        };
    
        fetchProduct();
    }, [params.id]);

    const addToCart = (event, product) => {
        //console.log(product);
        event.preventDefault();

        let _cart = { ...cart };
        if (!_cart.items) {
            _cart.items = {};
        }
        if (_cart.items[product.id]) {
            _cart.items[product.id] += 1;
        } else {
            _cart.items[product.id] = 1;
        }

        if (!_cart.totalItems) {
            _cart.totalItems = 0;
        }
        _cart.totalItems += 1;
        setCart(_cart);
        setIsAdding(true);
        setTimeout(()=>{
            setIsAdding(false);
        },1000);

        // const cart = {
        //     items: {
        //         id: quantity
        //     },
        //   totalItems : totaltemsvalue
        // }

    }
    

    return (
        <div className='container mx-auto mt-12'>
            <button className='mb-12 font-bold' onClick={()=>{ navigate(-1)}}>Back</button>
            <div className='flex'>
                <img src={product.image} alt={product.name} width="200" height="auto" />
                <div className='ml-16'>
                    <h1 className='text-xl font-bold'>{product.name}</h1>
                    <div className='text-md'>{product.size}</div>
                    <div className='font-bold mt-2'>Rs {product.price}</div>
                    <button onClick={(e) => { addToCart(e, product) }} className={`${isAdding ? 'bg-green-500' : 'bg-yellow-500'} py-1 px-4 rounded-full font-bold`}>ADD{isAdding ? 'ED' : ''}</button>
                </div>
            </div>
        </div>
    );
}

export default ProductPage;
